import { KnowledgeMonitoringApi } from 'api';
import useUserData from 'hooks/useUserData';
import { useEffect, useState } from 'react';
import { ParticipantsForMunicipality, ParticipantsForRegion, Test } from '../models';

const useFetchMonitoringData = () => {
  const { isRegion, isLargeCity } = useUserData() || {};
  const [tests, setTests] = useState<Test[]>();
  const [participants, setParticipants] = useState<ParticipantsForMunicipality | ParticipantsForRegion>();

  async function fetchSamples() {
    const participants =
      isRegion || isLargeCity
        ? await KnowledgeMonitoringApi.getTestParticipantsForRegion()
        : await KnowledgeMonitoringApi.getTestParticipantsForMunicipality();

    setParticipants(participants);
  }
  async function fetch() {
    const tests = await KnowledgeMonitoringApi.getTestsList();
    setTests(tests);
  }

  useEffect(() => {
    fetch();
    fetchSamples();
  }, []);

  return { tests, participants };
};

export default useFetchMonitoringData;

export type FetchMonitoringData = ReturnType<typeof useFetchMonitoringData>;
